<template>
  <TheChat :loading="isConnecting" />
</template>
<script>
import TheChat from '@/components/Support/TheChat'
import { supportStore } from '@/mixins/supportMixin'
import { authStore } from '@/mixins/authStoreMixin'

export default {
  name: 'Support',

  components: {
    TheChat
  },

  data: () => ({
    connecting: false
  }),

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch(`${supportStore.moduleName}/${supportStore.actionTypes.ACTION_DISCONNECT}`, true)
    next()
  },

  computed: {
    isConnecting() {
      return this.$store.getters[`${supportStore.moduleName}/${supportStore.getterTypes.GETTER_IS_CONNECTING}`]
    },
    loggedIn() {
      return this.$store.getters[`${authStore.moduleName}/${authStore.getterTypes.GETTER_IS_AUTHENTICATED}`]
    }
  },

  watch: {
    async loggedIn(v) {
      if (v) {
        try {
          await this.$store.dispatch(`${supportStore.moduleName}/${supportStore.actionTypes.ACTION_CONNECT}`)
        } catch (error) {
          
        }
      }
    }
  },

  async created() {
    try {
      await this.$store.dispatch(`${supportStore.moduleName}/${supportStore.actionTypes.ACTION_CONNECT}`)

    } catch (error) {}
  }
}
</script>
